import { render, staticRenderFns } from "./payment-check-form.vue?vue&type=template&id=bf017c9a"
import script from "./payment-check-form.vue?vue&type=script&lang=js"
export * from "./payment-check-form.vue?vue&type=script&lang=js"
import style0 from "./payment-check-form.vue?vue&type=style&index=0&id=bf017c9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports